<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      title="存货数据"
      id-key="UserId"
      form-label-width="100px"
    >
      <template slot="form">
        <el-form-item label="存货数据">
            <el-select v-model="value" filterable>
                <el-option v-for="(item) in list" :key="item.ProductId" :label="item.ProductName" :value="item.ProductId"></el-option>
            </el-select>
        </el-form-item>
      </template>

      <template slot="footer">
        <el-button type="primary" @click="save">确定</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";



export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data(){
    return {
      api: require('@/api/ba/product').default,
      value: '',
      list: [],
       
    }
  },
  methods: {
    init(){
      this.api.list({Status: 1}).then(res => {
        if(res.Code === 0){
          this.list = res.Data;
        }
      })
    },
    save(){

        let itme = this.list.filter(item => {
          return item.ProductId === this.value;
        })[0]

        this.$emit('saved', itme);
        this.close();
    },
   


  }




};
</script>


